
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/[podcast]",
      function () {
        return require("private-next-pages/podcast/[podcast].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcast/[podcast]"])
      });
    }
  